<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <DxToolbar class='select-group'>
      <DxItem
        #default
        location="before"
        locate-in-menu="never"
      >
        <div class="toolbar-label"><b>년도 : </b></div>
      </DxItem>
      <DxItem
        :options="selectBoxYearOptions"
        location="before"
        locate-in-menu="auto"
        widget="dxSelectBox"
      />
      <DxItem
        #default
        location="before"
        locate-in-menu="never"
      >
        <div class="toolbar-label"><b>월 : </b></div>
      </DxItem>
      <DxItem
        :options="selectBoxMonthOptions"
        location="before"
        locate-in-menu="auto"
        widget="dxSelectBox"
      />
      <DxItem
        :options="buttonOption"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
      />
    </DxToolbar>
    <DxPivotGrid
      ref="refPivot"
      :allow-sorting-by-summary="true"
      :allow-sorting="true"
      :allow-filtering="true"
      :allow-expand-all="true"
      :show-borders="true"
      :show-column-grand-totals="false"
      :show-row-grand-totals="true"
      :show-row-totals="false"
      :show-column-totals="true"
      :data-source="dataSource"
      :height='pivotHeight'
      @cell-prepared = 'onCellPrepared'
      @exporting="onExporting"
    >
      <DxFieldChooser
        :enabled="false"
        :height="400"
      />
      <DxExport
        :enabled="true"
        :file-name="excelTitle"
      />
    </DxPivotGrid>
    <DxPopup2
      :visible.sync="isInputPopup"
      :width="1200"
      :height="590"
      title="구매품 입고"
    >
      <div style="display: flex" >
        <div class="pressDeliveryList" style="margin: 0px 21px 0 0px;" v-if="!isMaterialType">
          <dx-data-grid
            ref="refDeliveryGrid"
            :data-source="deliveryDetailListInfo"
            :show-borders="true"
            :show-row-lines="false"
            :show-column-lines="true"
            :hover-state-enabled="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :allow-column-reordering="true"
            :row-alternation-enabled="true"
            height="510"
            width="550"
            :focused-row-enabled="true"
            key-expr="seqId"
            :selected-row-keys="selectedRowKeys"
            @selection-changed="onSelectionChangedDetail"
            @toolbar-preparing='onToolbarPreparing'
          >
            <DxSearchPanel
              :visible="false"
              :width="120"
              placeholder="검색..."
            />
            <DxSwitch :value="true"/>
            <DxSelection
              :show-check-boxes-mode="checkBoxesMode"
              :allowSelectAll="true"
              mode="multiple"/>
            <DxEditing
              :allow-updating="true"
              :allow-adding="false"
              :allow-deleting="false"
              :select-text-on-edit-start="true"
              mode="batch"
            />
            <DxColumn
              :allow-editing="false"
              :fixed="false"
              caption="거래처명"
              data-field="거래처명"
              :min-width="100"
            />
            <DxColumn
              :allow-editing="false"
              :fixed="false"
              caption="품번"
              data-field="품번"
              :min-width="100"
            />
            <DxColumn
              :allow-editing="true"
              caption="예정/입고"
              data-field="납품수량"
              data-type="number"
              :visible="true"
              format="#,##0"
              :min-width="60"
            />
            <DxColumn
              :allow-editing="false"
              caption="실수량"
              data-field="실납품수량"
              data-type="number"
              :visible="true"
              format="#,##0"
              :min-width="60"
            />
            <DxSummary>
              <DxTotalItem
                value-format="#,##0"
                column="거래처명"
                display-format="{0} (건)"
              />
            </DxSummary>
            <dx-paging :enabled="false" />
            <dx-scrolling
              mode="virtuala"
              show-scrollbar="always"
              :use-native="false"
            />
            <dx-sorting mode="multiple" />
          </dx-data-grid>
        </div>
        <div>
          <dx-data-grid
            ref="refGoodsInputGrid"
            :data-source="goodsInputListInfo"
            :show-borders="true"
            :show-row-lines="false"
            :show-column-lines="true"
            :hover-state-enabled="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :allow-column-reordering="true"
            :row-alternation-enabled="true"
            :focused-row-enabled="true"
            key-expr="seqId"
            height="510"
            :focused-row-key.sync="focusedRowKey"
            @row-inserting="onRowInserting"
            @row-inserted="onRowInserted"
            @row-updated='onRowUpdated'
            @row-removed="onRowRemoved"
            @row-removing="onRowRemoving"
            @init-new-row='onInitNewRow'
            @toolbar-preparing='onToolbarPreparingRightGrid'
            @editor-preparing='onEditorPreparing'
          >
            <DxSearchPanel
              :visible="true"
              :width="120"
              placeholder="검색..."
            />
            <DxEditing
              :allow-deleting="isEditable"
              :allow-updating="isEditable"
              :allow-adding="false"
              :use-icons="true"
              mode="row"
            />
            <DxColumn
              :allowEditing='false'
              :fixed="true"
              caption="입고일"
              data-field="발생일자"
              dataType='date'
              format='yyyy-MM-dd'>
              <dx-required-rule message="항목을 선택하세요"/>
            </DxColumn>
            <DxColumn
              :allowEditing='isIdEdit'
              caption="품번"
              data-field="품번"
              :visible='true'
              :fixed="true"
              edit-cell-template="productionGridTemplate"
            >
              <dx-required-rule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
              :allow-editing="true"
              caption="입고수량"
              data-field="수량"
              format="#,##0"
              :visible='true'
            >
              <dx-required-rule message="항목을 선택하세요"/>
            </DxColumn>
            <DxColumn
              :allow-editing="false"
              caption="입고업체"
              data-field="입고업체"
              :visible='true'
              edit-cell-template="companyGridTemplate"
            >
             <DxLookup
                :data-source="companyInfoList"
                display-expr="거래처명"
                value-expr="거래처코드"
              />
              <dx-required-rule message="항목을 선택하세요"/>
            </DxColumn>
            <DxColumn
              :allow-editing="true"
              caption="마감월"
              data-field="마감일자"
              dataType='date'
              format='yyyy-MM'
            >
              <dx-required-rule message="항목을 선택하세요"/>
            </DxColumn>
            <DxSummary>
              <DxTotalItem
                value-format="#,##0"
                show-in-column="품번"
                display-format="{0} (건)"
              />
            </DxSummary>
            <dx-paging :enabled="false" />
            <dx-scrolling
              mode="virtual"
            />
            <dx-sorting mode="multiple" />
            <template #productionGridTemplate="{ data: cellInfo }">
              <ProductionGridComponent
                ref="refProductGrid"
                option="품번"
                :value="cellInfo.value"
                :onValueChanged="cellInfo.setValue"
                @selected-pcode='setProductionCode'
                :productionInfo='productionList'
                :isEdit="true"
              />
            </template>
            <template #companyGridTemplate="{ data: cellInfo }" >
              <CompanyGridComponent
                ref="refCompanyGrid"
                :value="cellInfo.value"
                :on-value-changed="cellInfo.setValue"
                @selected-company='setCompnayCode'
                :companyInfo='companyInfoList'
              />
            </template>
          </dx-data-grid>
        </div>
      </div>
    </DxPopup2>
    <DxPopup2
      :visible.sync="isPivotInputPopup"
      :width="600"
      :height="168"
      title="자재입고등록"
      >
        <DxForm
          :form-data="formInputData"
          >
          <DxFormItem
              :col-count="2"
              :col-span="2"
              item-type="group"
            >
              <DxFormItem
                data-field="입고일자"
                editor-type="dxDateBox"
                :editor-options="{displayFormat: 'yyyy-MM-dd'}"
                v-model="selectedDate"
              />
              <DxFormItem
                data-field="품번"
                :disabled="true"
              />
              <DxFormItem
                data-field="입고수량"
                editor-type="dxNumberBox"
                :editor-options="qtyEditorOption"
                >
                <dx-required-rule message="항목을 입력하세요"/>
              </DxFormItem>
              <DxFormItem
                data-field="입고업체명"
                caption="입고업체"
                :disabled="true"
              />
              <DxFormItem
                data-field="입고업체"
                :visible="false"
              />
              <DxFormButtonItem
                :col-span="2"
                :button-options="saveButtonOptions"
                horizontal-alignment="right"
              />
          </DxFormItem>
        </DxForm>
    </DxPopup2>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxColumn, DxPaging, DxEditing, DxSorting, DxSearchPanel, DxSummary, DxTotalItem, DxLookup, DxSelection } from 'devextreme-vue/data-grid'
import { DxSwitch } from 'devextreme-vue/switch'
import { DxPivotGrid, DxFieldChooser, DxExport } from 'devextreme-vue/pivot-grid'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import { DxForm, DxItem as DxFormItem, DxButtonItem as DxFormButtonItem } from 'devextreme-vue/form'
import { DxPopup as DxPopup2 } from 'devextreme-vue/popup'
import { DxRequiredRule } from 'devextreme-vue/validator'
import ProductionGridComponent from '../../share/component/ProductionGridComponent.vue'
import CompanyGridComponent from '../../share/component/CompanyGridComponent.vue'
import axios from 'axios'

// excel
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportPivotGrid } from 'devextreme/excel_exporter'

export default {
  name: 'OthersPurchaseInputPivotComponent',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      thisYear: null,
      selectBoxYearOptions: null,
      selectBoxMonthOptions: null,
      selectBoxVendorOptions: null,
      selectedDate: null,
      selectedMonth: null,
      dailyStatus: null,
      dataSource: null,
      excelTitle: null,
      pivotHeight: null,
      총합계금액: null,
      isInputPopup: false,
      isPivotInputPopup: false,
      inputData: null,
      productionList: null,
      companyInfoList: null,
      selectedProductionCode: null,
      isInputSwitch: false,
      switchOption: {
        text: '입고모드',
        width: 60,
        type: 'default',
        value: this.isInputSwitch,
        onValueChanged: (args) => {
          this.isInputSwitch = args.value
        }
      },
      buttonOption: {
        text: '자재입고',
        type: 'default',
        onClick: (args) => {
          this.isInputPopup = true
          this.refreshDeliveryList()
          this.refreshInputGoodsList()
        }
      },
      saveButtonOptions: {
        text: '저장',
        width: 120,
        class: 'DxFormButtonItem',
        type: 'default',
        onClick: (args) => {
          this.onSaveButton()
        }
      },
      purchaseInfoList: [],
      // popup in data-grid
      inputQty: null,
      selectedDay: null,
      goodsType: 'others',
      deliveryDetailListInfo: null,
      focusedRowKeyOrder: null,
      focusedRowKey: null,
      goodsInputListInfo: [],
      selectedCompanyCode: null,
      seqId: null,
      입고일: null,
      checkBoxesMode: 'always',
      is납품예정: false,
      inputBtn: null,
      issueDateOption: null,
      // pivot popup
      formInputData: null,
      qtyEditorOption: null,
      isInsertEvent: false,
      selectedRowsData: [],
      // edit 설정 관련
      isIdEdit: true,
      isDeletableFlag: true,
      coilBatchInputBtn: null,
      coilBatchInputSwitchBtn: null
    }
  },
  props: {
    pType: {
      type: String,
      default: ConstDef.구매품
    },
    materialType: {
      type: String,
      default: null
    },
    company: {
      type: String,
      default: null
    },
    selectedVendor: {
      type: String,
      default: null
    }
  },
  components: {
    Loading,
    DxPivotGrid,
    DxFieldChooser,
    DxToolbar,
    DxItem,
    DxExport,
    DxPopup2,
    DxRequiredRule,
    ProductionGridComponent,
    CompanyGridComponent,
    DxDataGrid,
    DxScrolling,
    DxColumn,
    DxEditing,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxSummary,
    DxTotalItem,
    DxLookup,
    DxForm,
    DxFormItem,
    DxFormButtonItem,
    DxSelection,
    DxSwitch
  },
  computed: {
    isMaterialType () {
      return (this.pType === ConstDef.구매품 && this.materialType.includes(ConstDef.부자재))
    },
    selectedRowKeys () {
      return this.selectedRowsData.map((deliveryDetailListInfo) => deliveryDetailListInfo.seqId)
    }
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.$store.commit('deleteInoutList')
    this.selectedDay = AppLib.getToday()
    this.companyInfoList = this.$_.sortBy(this.$store.getters.getPartnersInfo, '거래처명')
    this.refreshDeliveryList()
    this.refreshProduction()
    this.qtyEditorOption = {
      onEnterKey: (args) => {
        this.onSaveButton()
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.init()
    }, 500)
    this.pivotHeight = (screen.height - 250) * 0.9
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

    /* edit 설정 관련 start */
    isEditable () {
      let baseDate = this.selectedDay.substring(0, 7)
      let result = false
      if (!AppLib.isInOutCRUDable(baseDate)) {
        this.inputBtn.option({ disabled: true })
        this.coilBatchInputBtn.option({ disabled: true })
        result = false
      } else {
        this.inputBtn.option({ disabled: false })
        this.coilBatchInputBtn.option({ disabled: false })
        result = true
      }
      return result
    },
    onEditorPreparing (e) {
      if (e.dataField === '수량' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    /* edit 설정 관련 end */
    onExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.excelTitle)
      exportPivotGrid({
        component: e.component,
        worksheet,
        customizeCell: ({ pivotCell, excelCell }) => {
          console.log(excelCell)
          if (excelCell._row._number === 2) {
            excelCell.style.height = 3000
          }
          if (excelCell._value.model.value === 0) {
            excelCell._value.model.value = ''
          }
          if (AppLib.isDataCell(pivotCell) || AppLib.isTotalCell(pivotCell) || AppLib.isCostTotalCell(pivotCell)) {
            const appearance = this.getConditionalAppearance(pivotCell)
            Object.assign(excelCell, this.getExcelCellFormat(appearance))
          }
          const borderStyle = { style: 'thin', color: { argb: 'FF7E7E7E' } }
          excelCell.border = {
            bottom: borderStyle,
            left: borderStyle,
            right: borderStyle,
            top: borderStyle
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.excelTitle}-${this.company}.xlsx`)
        })
      })
      e.cancel = true
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()

      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.selectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.thisYear,
        onValueChanged: (args) => {
          this.$store.commit('deleteInoutList')
          this.thisYear = args.value
          this.$emit('refresh-input-vendor-list', `${this.thisYear + '-' + this.selectedMonth}`)
          this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
        }
      }
      tempArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          tempArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          tempArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      this.selectBoxMonthOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'value',
        displayExpr: 'name',
        value: this.selectedMonth,
        onValueChanged: (args) => {
          this.$store.commit('deleteInoutList')
          this.selectedMonth = args.value
          this.$emit('refresh-input-vendor-list', `${this.thisYear + '-' + this.selectedMonth}`)
          this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
        }
      }
      console.log(this.selectedVendor)
      this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
    },
    onSaveButton () {
      const row = {
        data: {
          발생일자: this.formInputData.입고일자,
          입출고구분: ConstDef.자재입고,
          품번: this.formInputData.품번,
          수량: this.formInputData.입고수량,
          입고업체: this.formInputData.입고업체
        }
      }
      let firstDay = `${AppLib.getToday().substring(0, 7)}-01 00:00:00`
      if (row.data.발생일자 !== null && (typeof row.data.발생일자) === 'object') {
        row.data.발생일자 = row.data.발생일자.getTime()
      }
      if (firstDay > row.data.발생일자) {
        this.$snotify.info('전월날자에 입고 할 수 없습니다.')
        return
      }
      this.onRowInserted(row)
      this.isPivotInputPopup = false
      this.isInsertEvent = true
      this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
    },
    onCellPrepared (e) {
      if (e.area === 'data') {
        if (e.cell.value === 0) {
          this.$Q(e.cellElement).find('span').text('')
        }
      }
    },
    makeDaily (dailyStatus) {
      if (dailyStatus.length === 0) {
        this.setInitDataSource()
        return
      }
      const mDay = AppLib.getMonthLastDay(this.thisYear, this.selectedMonth)
      let timeStamp
      for (let i = 1; i <= mDay; i++) {
        timeStamp = AppLib.getTimestampFromformat(this.thisYear, this.selectedMonth, i)
        let where = this.$_.findWhere(dailyStatus, { 발생일: timeStamp, 품번: dailyStatus[0].품번 })
        if (where === undefined) {
          const temp = {
            마감처: dailyStatus[0].마감처,
            차종: dailyStatus[0].차종,
            코드명: dailyStatus[0].코드명,
            발생일: timeStamp,
            품명: dailyStatus[0].품명,
            품번: dailyStatus[0].품번,
            자재유형: dailyStatus[0].자재유형,
            전월재고: dailyStatus[0].전월재고,
            제품계획수량: dailyStatus[0].제품계획수량,
            월수량: dailyStatus[0].월수량,
            그룹수량: 0,
            금액: dailyStatus[0].금액
          }
          dailyStatus.push(temp)
        }
      }
      this.setInitDataSource()
    },
    refreshDataGridFromParent (vendorCode) {
      this.refreshDataGrid(this.thisYear, this.selectedMonth, vendorCode)
    },
    async refreshDataGrid (year, month, vendorCode) {
      this.dailyStatus = this.$store.getters.getPurchaseInfoList(vendorCode)
      this.excelTitle = `${year}-${month}`
      if (this.dailyStatus !== null && !this.isInsertEvent) {
        this.makeDaily(this.dailyStatus)
        this.isInsertEvent = false
      } else {
        this.isLoading = true
        const param = {
          startDate: `${year}-${month}-01`,
          endDate: `${year}-${month}-${AppLib.getMonthLastDay(year, month)} 23:59:59`,
          품목유형: this.pType,
          자재유형: this.materialType,
          거래처코드: 'ALL'
        }
        this.$_sp.runNoEncodeFindProc('spFindAllInputPivotByDateAndType', param)
          .then((data) => {
            this.isLoading = false
            this.dailyStatus = this.$_sp.MakeModel(data)
            console.log(this.dailyStatus)
            this.$store.commit('savePurchaseInoutList', { data: this.dailyStatus, option: param })
            this.dailyStatus = this.dailyStatus.filter(item => item.입고업체 === vendorCode)
            this.makeDaily(this.dailyStatus)
            this.pivotHeight = (screen.height - 250) * 0.9
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    setInitDataSource () {
      this.dataSource = null
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: '',
            dataField: '마감처',
            area: 'row',
            width: '120',
            expanded: true
          },
          {
            caption: '',
            dataField: '차종',
            area: 'row',
            width: '40',
            expanded: true
          },
          {
            caption: '',
            dataField: '품번',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            caption: '',
            dataField: '제품계획수량',
            area: 'row',
            width: '100',
            format: '#,##0',
            expanded: true
          },
          {
            caption: '',
            dataField: '월수량',
            area: 'row',
            width: '100',
            format: '#,##0',
            expanded: true
          },
          {
            caption: '',
            dataField: '전월재고',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            dataField: '발생일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month',
            expanded: true
          },
          {
            dataField: '발생일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'day'
          },
          {
            caption: '수량',
            dataField: '그룹수량',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }
        ],
        store: this.dailyStatus
      })
    },
    getExcelCellFormat ({ fill, font, bold }) {
      return {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: fill } },
        font: { color: { argb: font }, bold }
      }
    },
    getConditionalAppearance (cell) {
      if (AppLib.isCostTotalCell(cell)) {
        return { font: '001aff', fill: 'ffffff', bold: false }
      }
      if (AppLib.isTotalCell(cell)) {
        return { fill: 'F2F2F2', font: '3F3F3F', bold: true }
      }
      return { font: '000000', fill: 'ffffff' }
    },
    /* *************************** popup method 영역********************* */
    setProductionCode (code) {
      this.selectedProductionCode = code
    },
    setCompnayCode (code) {
      this.selectedCompanyCode = code
    },
    refreshDeliveryList () {
      const param = {
        납품일자: this.selectedDay,
        자재유형: this.goodsType
      }
      this.$_sp.runNoEncodeFindProc('spFindAllB2bDeliveryListByDate', param)
        .then((data) => {
          this.deliveryDetailListInfo = this.$_sp.MakeModel(data)
        })
    },
    refreshProduction () {
      this.$_sp.runNoEncodeFindProc('spFindAllGoodsByGoodsTypeAndGenType', { 품목유형: ConstDef.구매품, 자재유형: this.materialType })
        .then((data) => {
          this.productionList = this.$_sp.MakeModel(data).filter(item => item.자재유형 !== ConstDef.외주직납품)
          console.log(this.productionList)
        })
    },
    refreshInputGoodsList () {
      const param = {
        입출고구분: ConstDef.자재입고,
        발생일자: this.selectedDay,
        materialType: this.materialType
      }
      this.$_sp.runNoEncodeFindProc('spFindAllInputGoosListByDelNoAndDateAndGoodsType', param)
        .then((data) => {
          this.goodsInputListInfo = this.$_sp.MakeModel(data)
          console.log(this.goodsInputListInfo)
        })
    },
    onSelectionChangedDetail ({ selectedRowsData }) {
      this.is납품예정 = true
      if (selectedRowsData !== null && selectedRowsData !== undefined && selectedRowsData.length > 0) {
        const b2bDataGrid = this.$refs.refDeliveryGrid.instance
        for (let i = 0; i < selectedRowsData.length; i++) {
          const selectedArray = selectedRowsData[i]
          if (selectedArray.납품확인 === true) {
            selectedRowsData.splice(i, 1)
            b2bDataGrid.deselectRows(selectedArray.seqId)
          }
        }
        this.selectedRowsData = selectedRowsData
      }
    },
    onInitNewRow (row) {
      console.log(this.selectedDay)
      row.data.발생일자 = `${this.selectedDay} 10:00:00`
      row.data.마감일자 = `${row.data.발생일자.substring(0, 7)}-01 10:00:00`
      row.data.입고업체 = this.selectedCompanyCode = this.selectedVendor
      this.isIdEdit = true
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>납품예정일 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.selectedDay,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            calendarOptions: { min: `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01` },
            onValueChanged: (args) => {
              this.selectedDay = args.value
              this.$refs.refGoodsInputGrid.instance.cancelEditData()
              this.isEditable()
              this.refreshDeliveryList()
              this.refreshInputGoodsList()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            text: '선택 입고',
            width: 80,
            class: 'DxFormButtonItem',
            type: 'default',
            onInitialized: args => {
              this.coilBatchInputBtn = args.component
            },
            onClick: (args) => {
              this.$refs.refDeliveryGrid.instance.saveEditData()
              setTimeout(() => {
                const rowLength = this.selectedRowsData.length
                console.log(this.selectedRowsData)
                const param = []
                for (let i = 0; i < rowLength; i++) {
                  const formatDate = AppLib.formatDateFromTimeStamp(this.selectedRowsData[i].납품일자)
                  let item = {}
                  item.발생일자 = `${formatDate.substring(0, 10)} 10:00:00`
                  item.마감일자 = `${formatDate.substring(0, 7)}-01 10:00:00`
                  item.입고업체 = this.selectedRowsData[i].거래처코드
                  item.품번 = this.selectedRowsData[i].품번
                  item.수량 = this.selectedRowsData[i].납품수량
                  item.발주번호 = this.selectedRowsData[i].seqId
                  item.입출고구분 = ConstDef.자재입고
                  item.createid = this.userInfo.userName
                  item.updateid = this.userInfo.userName
                  item.createtime = AppLib.getNow()
                  param.push(item)
                  // if (this.selectedRowsData[i].납품확인 === false) {
                  //   setTimeout(() => {
                  //     this.onRowInserted({ data: this.selectedRowsData[i] })
                  //   }, rowLength * 100)
                  // }
                  if (rowLength - 1 === i) this.$refs.refDeliveryGrid.instance.deselectAll()
                }
                this.batchSave(param, false)
              }, 0)
            }
          }
        }
      )
    },
    onToolbarPreparingRightGrid (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            width: 30,
            icon: 'add',
            onInitialized: (args) => {
              this.inputBtn = args.component
            },
            onClick: (args) => {
              this.is납품예정 = false
              this.$refs.refGoodsInputGrid.instance.addRow()
            }
          }
        }
      )
    },
    onRowInserting (row) {
      if (this.selectedOrder !== null && this.selectedOrder !== undefined) {
        if (this.selectedOrder.납품확인 === true) {
          this.$snotify.error('이미 입고처리 되었습니다.')
          row.cancel = true
        }
      }
      // var date = new Date()
      let firstDay = `${AppLib.getToday().substring(0, 7)}-01 00:00:00`
      firstDay = AppLib.getTimestampFromString(firstDay)
      if (row.data.발생일자 !== null && (typeof row.data.발생일자) === 'object') {
        row.data.발생일자 = row.data.발생일자.getTime()
      }
      if (firstDay > row.data.발생일자) {
        this.$snotify.info('전월날자에 입고 할 수 없습니다.')
        row.cancel = true
      }
      console.log(row)
    },
    async onRowInserted (row) {
      if (row.data.발생일자 !== null && (typeof row.data.발생일자) === 'object') {
        row.data.발생일자 = row.data.발생일자.getTime()
      }
      row.data.입출고구분 = ConstDef.자재입고
      row.data.발주번호 = row.data.발주번호 !== undefined ? row.data.발주번호 : AppLib.uuidSequential()
      row.data.createid = this.userInfo.userName
      row.data.updateid = this.userInfo.userName
      row.data.createtime = AppLib.getNow()
      this.batchSave([row.data], true)
    },
    batchSave (rows, isNewRow) {
      let axiosArray = []
      axiosArray.push(this.$_sp.runInsertSqlProc('창고수불', ['seqId'], rows))
      if (isNewRow === false) {
        const array = []
        rows.forEach(item => {
          const obj = {
            seqId: item.발주번호,
            납품확인: true,
            실납품수량: item.수량
          }
          array.push(obj)
        })
        axiosArray.push(this.$_sp.runUpdateSqlProc('협력사거래내역서', ['seqId'], null, array))
      }
      axios.all(axiosArray)
        .then(axios.spread((...reponse) => {
          this.$snotify.info('입고처리 되었습니다.')
          this.refreshDeliveryList()
          this.refreshInputGoodsList()
          this.isInsertEvent = true
          this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
        }))
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdated (row) {
      const param = [{
        seqId: row.data.seqId,
        수량: row.data.수량,
        마감일자: row.data.마감일자
      }]
      row.data.updatetime = AppLib.getNow()
      this.$_sp.runUpdateSqlProc('창고수불', ['seqId'], null, param)
        .then((data) => {
          this.$snotify.info('수정되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemoved (row) {
      const 창고수불 = this.$_sp.runDeleteSqlProc('창고수불', [{ 발주번호: row.data.발주번호 }])
      const 협력사거래내역서 = this.$_sp.runUpdateSqlProc('협력사거래내역서', ['seqId'], null, [{ seqId: row.data.발주번호, 납품확인: false, 실납품수량: null }])
      axios.all([창고수불, 협력사거래내역서])
        .then(axios.spread((...reponse) => {
          const where = this.$_.findWhere(this.deliveryDetailListInfo, { seqId: row.data.발주번호 })
          if (where !== undefined) {
            where.실납품수량 = null
            where.납품확인 = false
          }
          this.$refs.refDeliveryGrid.instance.refresh()
        }))
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemoving (row) {
      const 재고관리기준시간 = this.$store.getters.getSysParamByKey('재고관리기준시간')
      if (AppLib.isLessThisMonth(`${재고관리기준시간}:00`, row.data.발생일자)) {
        this.$snotify.info('전월 입고는 마감되어 삭제할 수 없습니다.')
        row.cancel = true
      }
    }
  }
}
</script>

<style lang="scss">
  .dx-button{
    margin-top: 5px;
  }
  .pressDeliveryList {
    .dx-datagrid-cancel-button {
      display: none;
    }
    .dx-datagrid-save-button {
      display: none;

    }
  }
</style>
